import { faker } from '@faker-js/faker';
import { IClaimMessengerMetadata } from 'app/claims/components/messenger/interfaces/claim-messenger-metadata.interface';
import { makeClaimConversationMetadataConversation } from 'app/mocks/factories/claims/makes/make-claim-conversation-metadata-conversation';

const predefinedTopics = [
    'general',
    'missing_package',
    'damaged_item',
    'claim_status_update',
    'tracking_discrepancy',
] as const;

export function makeClaimConversationMetadata(overrides: Partial<IClaimMessengerMetadata> = {}): IClaimMessengerMetadata {
    const claimId = overrides.claimId ?? faker.number.int({ min: 100000, max: 999999 });
    const conversations =
        overrides.conversations ??
        predefinedTopics.map((topic) => makeClaimConversationMetadataConversation({ topic }));

    return {
        claimId,
        conversations,
        ...overrides,
    };
}
